import { Navigate } from 'react-router-dom';
import { IRoute, PortalRoutePath } from '@models';
import { Tr } from '@utils';
import { PackageDealsIcon } from '@components/icons';
import { Permission } from '@services';
import { PackageDeals } from './PackageDeals';
import { AddService } from './AddService';
import { EditService } from './EditService';
import { AddPackage } from './AddPackage';
import { EditPackage } from './EditPackage';

export const PACKAGE_DEALS_ROUTES: IRoute = {
	path: PortalRoutePath.PACKAGE_DEALS,
	icon: <PackageDealsIcon />,
	text: <Tr.Portal path="package-deal.title" />,
	canActivate: (_route, user) =>
		!!user?.isAdmin() ||
		!!user?.hasPermission([
			Permission.SERVICE_READ,
			Permission.SERVICE_WRITE,
			Permission.PACKAGE_DEAL_READ,
			Permission.PACKAGE_DEAL_WRITE
		]),
	children: [
		{
			path: '',
			element: <PackageDeals />
		},
		{
			path: 'add-service',
			hideFromMenu: true,
			element: <AddService />
		},
		{
			path: 'edit-service/:id',
			hideFromMenu: true,
			element: <EditService />
		},
		{
			path: 'add-package',
			hideFromMenu: true,
			element: <AddPackage />
		},
		{
			path: 'edit-package/:id',
			hideFromMenu: true,
			element: <EditPackage />
		},
		{
			index: true,
			path: '*',
			hideFromMenu: true,
			element: <Navigate to={{ pathname: '..' }} replace />
		}
	]
};
